/**
 * Сортировка от новых к старым по полю `date`.
 *
 * Записи из API и зашитые в код смешиваются в одном списке (новости, отчёты),
 * поэтому порядок задаётся датой, а не источником. Даты в формате ISO
 * (`2026-03-12`); записи без даты или с нераспознанной датой уходят в конец.
 */
export function byDateDesc(a, b) {
  const left = Date.parse(a.date);
  const right = Date.parse(b.date);

  if (Number.isNaN(left) && Number.isNaN(right)) return 0;
  if (Number.isNaN(left)) return 1;
  if (Number.isNaN(right)) return -1;

  return right - left;
}

export default byDateDesc;
